import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserMachinesService } from '@data-terminal/data-access/user-machines';
import {
    ManageAssistantsDialogComponent,
    ManageAssistantsDialogData,
} from '@data-terminal/feature-dialogs/dialogs/manage-assistants-dialog/manage-assistants-dialog.component';
import { SetAssistantsEntry } from '@data-terminal/shared-models/machine';
import { TranslateService } from '@ngx-translate/core';
import { filter, map, switchMap, take, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ManageAssistantsDialogService {
    readonly #dialog = inject(MatDialog);
    readonly #snackBar = inject(MatSnackBar);
    readonly #translateService = inject(TranslateService);
    readonly #userMachinesService = inject(UserMachinesService);

    public openDialog(data: ManageAssistantsDialogData): void {
        const dialogConfig: MatDialogConfig<ManageAssistantsDialogData> = {
            disableClose: true,
            width: '680px',
            height: '80%',
            data,
        };

        const dialog: MatDialogRef<ManageAssistantsDialogComponent, SetAssistantsEntry[]> = this.#dialog.open(
            ManageAssistantsDialogComponent,
            dialogConfig
        );

        dialog
            .afterClosed()
            .pipe(
                take(1),
                filter((setAssistantsEntries) => !!setAssistantsEntries?.length),
                map((setAssistantsEntries) => setAssistantsEntries as SetAssistantsEntry[]),
                switchMap((setAssistantsEntries) => this.#userMachinesService.setAssistants(setAssistantsEntries)),
                map((userMachines) => {
                    if (userMachines.error) {
                        return throwError(() => userMachines.error?.message);
                    } else {
                        return userMachines;
                    }
                })
            )
            .subscribe({
                error: (err) => {
                    this.#snackBar.open(
                        this.#translateService.instant(err?.message || err),
                        this.#translateService.instant('*.action.close'),
                        {
                            duration: 3000,
                            panelClass: 'hdmui-error',
                        }
                    );
                },
            });
    }
}
